import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
import EFOcats_import_lang from '../import/efocats_import_lang.js';

/**
 * パスワードチェッククラス
 */
export default class EFOcats_validate_password extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');

    let pattern = new RegExp(`^[a-z0-9!-~]{${efocats.pass.min},${efocats.pass.max}}$`, 'i');
    let patternCheck = false;
    let ErrorMesse = '';

    if (pattern.test(checkData.val())) {
      patternCheck = true;

      if (efocats.pass.limit.length > 0) {
        const PassLimit = efocats.pass.limit;

        for (let i = 0, j = PassLimit.length; i < j; i++) {
          pattern = new RegExp(this.limitPattern(PassLimit[i]));

          if (!pattern.test(checkData.val())) {
            patternCheck = false;
            ErrorMesse = EFOcats_import_lang.getValue(PassLimit[i], {min: efocats.pass.min, max: efocats.pass.max});
            break;
          }
        }
      }
    } else {
      ErrorMesse = EFOcats_import_lang.getValue('passwordLimit', {min: efocats.pass.min, max: efocats.pass.max});
    }

    if (!patternCheck) {
      result = new EFOcats_error_info('error', ErrorMesse, '', ErrorMesse);
    }

    return result;
  }

  /**
   * パスワード制限文字チェック用の正規表現を取得
   * @param {*} key
   */
  limitPattern(key) {
    const list = {
      mixRequired: `^(?=.*?[a-zA-Z])(?=.*?\\d)[a-zA-Z!-~\\d]{${efocats.pass.min},${efocats.pass.max}}$`,
      mixUpLow: `^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\\d)[a-zA-Z!-~\\d]{${efocats.pass.min},${efocats.pass.max}}$`,
      mixSymbol: `^(?=.*?[a-zA-Z])(?=.*?\\d)(?=.*?[!-/:-@[-\`{-~])[!-~]{${efocats.pass.min},${efocats.pass.max}}$`,
      mixAlphabetNumber: `^(?=.*?[a-zA-Z])(?=.*?\\d)[a-zA-Z\\d]{${efocats.pass.min},${efocats.pass.max}}$`,
      hankaku: /^[0-9a-zA-Z]*$/,
    };

    return list[key];
  }
}
